import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaFacebook, FaGithub } from 'react-icons/fa';
import './footer.css';

const Footer = () => {
  return (
    <footer>
      <a href="#home" className="footer__logo">Md. Asadul Rahman</a>
      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Skills</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/md-asadul-rahman/" target="_blank" rel="noreferrer" ><BsLinkedin className='social-logo'/></a>
        <a href="https://github.com/asadulR" target="_blank" rel="noreferrer" ><FaGithub className='social-logo'/></a>
        <a href="https://web.facebook.com/beingAsad.galib" target="_blank" rel="noreferrer" ><FaFacebook className='social-logo'/></a>
        <a href="https://drive.google.com/file/d/1miAYhbccLhwgrzHxBwPHc3g8X85H6JQM/view?usp=sharing" target="_blank" rel="noreferrer" className="btn">Download CV</a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Asadul 2022. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer